import React from 'react'
import imgHowToOne from '../../assets/landing/how-to-1.svg'
import imgHowToTwo from '../../assets/landing/how-to-2.svg'
import imgHowToThree from '../../assets/landing/how-to-3.svg'

import treeRight from '../../assets/landing/shape_tree_1.png'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/free-mode'
import { Autoplay } from 'swiper/modules'

const howToBuyData = [
  {
    id: '01',
    image: imgHowToOne,
    title: 'Buy with ETH',
    href: '',
    bg: '#D1F4FF',
    description:
      'Get a DeFi crypto wallet such as MetaMask or Trust Wallet. Connect it to the presale widget at the top of this page. Use ETH (ERC20) to purchase $LILPEPE.'
  },
  {
    id: '02',
    image: imgHowToTwo,
    title: 'Buy with USDT',
    href: '',
    bg: '#D3D5FF',
    description:
      'Transfer USDT to your wallet on ethereum network (ERC20), Make sure you have enough ETH to cover gas fees.'
  },
  {
    id: '03',
    image: imgHowToThree,
    title: 'Buy with Card',
    href: '',
    bg: '#FFFDCF',
    description:
      'Want to buy with card? You will still need a DeFi wallet, Click on learn more to check full guide on how to buy LILPEPE with your credit/debit card.'
  }
]

const HowToBuy = () => {
  return (
    <div className="bg-[#FEF537] w-full pb-12 relative">
      <div className="mt-[-80px]">
        {' '}
        <div className="w-full md:w-[100%] ml-[-2px] md:ml-[-5px] mt-[-120px] overflow-hidden py-3 sm:py-4 md:py-8 bg-[#000000] rotate-[7deg] md:rotate-[5deg] border-y-2 border-[#E7FF53]">
          <Swiper
            modules={[Autoplay]}
            slidesPerView={3}
            spaceBetween={10}
            breakpoints={{
              640: {
                slidesPerView: 4,
                spaceBetween: 30
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 30
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 30
              }
            }}
            loop={true}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: false
            }}
            speed={7000}
            allowTouchMove={false}
            className="w-full"
          >
            {[
              'LITTLE PEPE',
              'LITTLE PEPE',
              'LITTLE PEPE',
              'LITTLE PEPE',
              'LITTLE PEPE',
              'LITTLE PEPE',
              'LITTLE PEPE',
              'LITTLE PEPE',
              'LITTLE PEPE',
              'LITTLE PEPE'
            ].map((img, idx) => (
              <SwiperSlide key={idx}>
                <h4 className="uppercase text-[28px] md:text-[57px] font-black font-sourGummy text-[#E7FF53]">
                  {img}
                </h4>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="w-full md:w-[100%] ml-[-3px] md:ml-[-5px] mt-[-50px] md:mt-[-150px] overflow-hidden py-3 sm:py-4 md:py-8 bg-[#000000] rotate-[-6deg] md:rotate-[-4deg] border-y-2 border-[#E7FF53]">
          <Swiper
            modules={[Autoplay]}
            slidesPerView={3}
            spaceBetween={10}
            breakpoints={{
              640: {
                slidesPerView: 4,
                spaceBetween: 30
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 30
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 30
              }
            }}
            loop={true}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: false
            }}
            speed={7000}
            allowTouchMove={false}
            className="w-full"
          >
            {[
              'LITTLE PEPE',
              'LITTLE PEPE',
              'LITTLE PEPE',
              'LITTLE PEPE',
              'LITTLE PEPE',
              'LITTLE PEPE',
              'LITTLE PEPE',
              'LITTLE PEPE',
              'LITTLE PEPE',
              'LITTLE PEPE'
            ].map((img, idx) => (
              <SwiperSlide key={idx}>
                <h4 className="uppercase text-[28px] md:text-[57px] font-extrabold font-sourGummy text-[#E7FF53]">
                  {img}
                </h4>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      <div className="px-4">
        <div className="pt-16 pb-20 md:pb-3">
          <h2 className="uppercase text-[44px] md:text-[99px] font-sourGummy font-extrabold text-center pb-14">
            How to Buy
          </h2>
        </div>
        <img
          src={treeRight}
          alt="tree"
          className="absolute top-[140px] right-0 w-[200px] md:w-auto"
        />
        <div className="grid grid-cols-1 md:grid-cols-3 max-w-[1300px] w-full mx-auto gap-20 md:gap-8 py-6">
          {howToBuyData.map(item => (
            <div
              key={item.id}
              className={`relative flex flex-col items-center justify-center px-4 pt-4 pb-4 rounded-xl border-2 border-dashed font-sourGummy`}
              style={{
                background: `${item.bg}`
              }}
            >
              <div className="text-[32px] text-[#E3FF10] size-[100px] border-2 border-dashed rounded-full flex items-center justify-center absolute top-[-50px] left-[50px] bg-black">
                {item.id}
              </div>
              <img src={item.image} alt={item.title} />
              <h3 className="text-[24px] font-bold">{item.title}</h3>
              <p className="text-[18px] text-center">
                {item.description}{' '}
                <a
                  href={item.href}
                  className="text-[18px] underline text-[#006C28]"
                >
                  Learn More
                </a>
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default HowToBuy
